"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useCookies } from "next-client-cookies";

const DISMISS_DAYS = 7;

/** Shows a banner only on the home page until the visitor dismisses it. */
export const useDismissibleHomeBanner = (
  cookieName: string,
  isActive = true
) => {
  const pathname = usePathname();
  const cookies = useCookies();
  const [isVisible, setIsVisible] = useState(false);

  const isHomePage =
    pathname === "/" || /^\/[a-z]{2}(?:-[A-Za-z]{2})?$/.test(pathname);

  useEffect(() => {
    if (!isHomePage || !isActive) {
      setIsVisible(false);
      return;
    }

    setIsVisible(cookies.get(cookieName) !== "1");
  }, [cookieName, cookies, isActive, isHomePage]);

  const dismiss = () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + DISMISS_DAYS);
    cookies.set(cookieName, "1", { expires });
    setIsVisible(false);
  };

  return { isVisible, dismiss };
};
